var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManuscriptIconList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "44px",
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/VIP Copy 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/VIP-Copy-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    stroke: "#3E3A39",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/VIP-Copy-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,23.5 L26,23.5 M15,19.5 L26,19.5 M15,14.9172607 L26,14.9172607 M33,28 C33,28 33,29.3431458 33,31 C33,32.5976809 31.75108,33.9036609 30.1762728,33.9949073 L30,34 L13,34 L13.0008323,33.829 C14.1655899,33.4169287 15,32.3059078 15,31 C15,29.6940922 15,28 15,28 L33,28 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,28 L30,10 L11,10 L11,30.4266802 C11,32.4001702 12.3431458,34 14,34 L15,34",
    id: "Combined-Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManuscriptIconList);
export default __webpack_public_path__ + "static/media/manuscriptIconList.a3bbdaa660f6ecb06db784decd55ecd2.svg";
export { ForwardRef as ReactComponent };